import React from "react";
import { useAuth } from "contexts/AuthProvider";
import { Button } from "components/common/Button";
import { Callout } from "components/common/Callout";
import { AppApiError } from "@/lib/api/apps/apps";
import { useTermsPromptStore } from "@/stores/useTermsPromptStore";

/// A door's refusal as an error callout. A `terms_not_accepted` one offers
/// Review and goes once the Terms are accepted: it no longer holds.
export const RefusalCallout: React.FC<{ error: unknown; title?: string }> = ({
  error,
  title,
}) => {
  const { tosAccepted } = useAuth();
  const ask = useTermsPromptStore((s) => s.ask);
  if (!error) return null;
  const message = error instanceof Error ? error.message : String(error);
  const terms =
    error instanceof AppApiError && error.code === "terms_not_accepted";
  if (terms && tosAccepted) return null;
  return (
    <Callout
      variant="error"
      title={title}
      action={
        terms && (
          <Button variant="secondary" size="xs" onClick={() => ask(message)}>
            Review
          </Button>
        )
      }
    >
      {message}
    </Callout>
  );
};
